import styled from '@themes/theme'

export const MatchupDetailOneFoldWrap = styled.div`
  display: flex;
  margin-bottom: -2px;
  padding: 14px 14px 0;
  .one-fold-info {
    flex: 1;
    text-align: left;
    &--tit {
      margin-bottom: 3px;
      font-size: ${props=>props.theme.font.large};
      color: ${props=>props.theme.color.modalTxt};
    }
    &--txt-box {
      display: flex;
      flex-wrap: wrap;
      align-content: center;
      width: auto;
      height: 64px;
      padding: 6px 12px;
      border-radius: 6px;
      background: ${props=>props.theme.color.themeTxt};
      .sub-txt {
        color: ${props=>props.theme.color.modalSubTxt};
        font-weight: ${props=>props.theme.fontW.medium};
        &:first-of-type {
          width: 100%;
        }
      }
      .point-txt {
        color: ${props=>props.theme.color.pink};
      }
    }
  }
  .one-fold-img {
    width: 77px;
    height: 106px;
    margin-left: 21px;
  }
`
